import { inject, InjectionToken } from '@angular/core';
import { environment } from '@adm-web-env/environment';
import { AccessApi } from './access-api';
import { AccessHttpApi } from './access-http.api';

/**
 * Angular turns `ngDevMode` into `false` in an optimized build, so the branch with the mock leaves the production bundle. The mock is loaded with `import()` and not imported
 * statically: its data is built with calls at the top of the module, and the bundler keeps such a module even when nothing uses it.
 */
declare const ngDevMode: boolean | undefined;

interface AccessEnvironment { accessMock?: boolean }

type AccessMethod = (...args: unknown[]) => Promise<unknown>;

/** The mock behind the same interface: every call waits until the module with the mock is loaded. Dev only. */
function waitingFor(mock: Promise<AccessApi>): AccessApi {
  return new Proxy({} as AccessApi, {
    get: (_, name: string | symbol): AccessMethod | undefined => typeof name === 'symbol' ? undefined : (...args: unknown[]) => mock.then(api => (api[name as keyof AccessApi] as AccessMethod).apply(api, args))
  });
}

/**
 * The page talks to the backend through this token. Only `environment.ts` (the local one, `npm run adm-app`) may carry `accessMock: true`: then the page works on the in-module
 * mock without the backend. The flag is off by default and does not exist in the other environment files.
 */
export function accessApiFactory(): AccessApi {
  // The `import()` stays right inside this condition: the bundler drops a dead branch together with the module it loads, and keeps a chunk for an `import()` anywhere else.
  if (typeof ngDevMode !== 'undefined' && !!ngDevMode && (environment as unknown as AccessEnvironment).accessMock === true) {
    return waitingFor(import('../mock/access-mock.api').then(m => new m.AccessMockApi()));
  }
  return inject(AccessHttpApi);
}

export const ACCESS_API = new InjectionToken<AccessApi>('access page api', { providedIn: 'root', factory: accessApiFactory });
